module.exports = __webpack_public_path__ + "img/nf.3a9a88dc.svg";